import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { FiShoppingBag, FiUser, FiMenu, FiX, FiSearch } from 'react-icons/fi';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { currentUser, isAdmin, logout } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/shop?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchOpen(false);
      setSearchQuery('');
    }
  };

  const categories = [
    { label: 'Bracelets', path: '/shop?category=bracelets' },
    { label: 'Necklaces', path: '/shop?category=necklaces' },
    { label: 'Rings', path: '/shop?category=rings' },
    { label: 'Hand Chains', path: '/shop?category=hand-chains' },
  ];

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar__inner">
          {/* Logo */}
          <Link to="/" className="navbar__logo">
            <span className="logo-text">STONARI</span>
            <span className="logo-sub">OFFICIAL</span>
          </Link>

          {/* Center Nav */}
          <ul className="navbar__links">
            <li><Link to="/shop">All Jewellery</Link></li>
            {categories.map((cat) => (
              <li key={cat.label}><Link to={cat.path}>{cat.label}</Link></li>
            ))}
          </ul>

          {/* Right Icons */}
          <div className="navbar__actions">
            <button className="icon-btn" onClick={() => setSearchOpen(!searchOpen)} aria-label="Search">
              <FiSearch size={18} />
            </button>
            {currentUser ? (
              <div className="navbar__user-menu">
                <button className="icon-btn" aria-label="Account">
                  <FiUser size={18} />
                </button>
                <div className="user-dropdown">
                  <Link to="/account">My Account</Link>
                  <Link to="/orders">My Orders</Link>
                  {isAdmin && <Link to="/admin">Admin Panel</Link>}
                  <button onClick={logout}>Logout</button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="icon-btn" aria-label="Login">
                <FiUser size={18} />
              </Link>
            )}
            <Link to="/cart" className="icon-btn cart-btn" aria-label="Cart">
              <FiShoppingBag size={18} />
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>
            <button className="icon-btn mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
              {menuOpen ? <FiX size={20} /> : <FiMenu size={20} />}
            </button>
          </div>
        </div>

        {/* Search bar */}
        {searchOpen && (
          <div className="navbar__search">
            <form onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="Search jewellery..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                autoFocus
              />
              <button type="submit"><FiSearch size={16} /></button>
            </form>
          </div>
        )}

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="navbar__mobile">
            <ul>
              <li><Link to="/shop">All Jewellery</Link></li>
              {categories.map((cat) => (
                <li key={cat.label}><Link to={cat.path}>{cat.label}</Link></li>
              ))}
              <li><Link to="/cart">Cart ({cartCount})</Link></li>
              {currentUser ? (
                <>
                  <li><Link to="/account">My Account</Link></li>
                  <li><Link to="/orders">My Orders</Link></li>
                  {isAdmin && <li><Link to="/admin">Admin Panel</Link></li>}
                  <li><button onClick={logout}>Logout</button></li>
                </>
              ) : (
                <li><Link to="/login">Login / Register</Link></li>
              )}
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
